import Vue from "vue";
import Vuex from "vuex";
import language from "./config/data/language.json";
import native_capacitor from "@/config/js_helper/native_capacitor";

let storedid = localStorage.getItem("CapacitorStorage.language");
let langid = storedid ? storedid : 1;

Vue.use(Vuex);
var store = {
	state: {
		active_loader: true,
		is_dialog_active: false,
		other_dialog_active: false,
		type_language: langid,
		language: {
			1: language.AL,
			2: language.EN,
		},
		unconfirmedApplications: [], // For Topic applications
		unconfirmedProjectApplications: [], // For Project || Program || Initiative applications
	},
	getters: {
		getLanguageParameters: (state) => (parameter) => {
			return state.language[state.type_language][parameter];
		},
		getDialogActivity: (state) => {
			return state.is_dialog_active;
		},
		getUnconfirmedApplications: (state) => {
			return state.unconfirmedApplications;
		},
		getUnconfirmedProjectApplications: (state) => {
			return state.unconfirmedProjectApplications;
		},
	},

	mutations: {
		setNewLanguageType(state, lang) {
			state.type_language = lang;
			localStorage.setItem("CapacitorStorage.language", lang);
		},
		setDialogActivity(state, active) {
			state.is_dialog_active = active;
		},
		setOtherDialogActivity(state, active) {
			state.other_dialog_active = active;
		},
		addUnconfirmedApplication(state, application) {
			const existingIndex = state.unconfirmedApplications.findIndex(
				(app) => app.email === application.email
			);
			if (existingIndex !== -1) {
				// If an application with the same email exists, update its data
				state.unconfirmedApplications[existingIndex] = application;
			} else {
				// Otherwise, add the new application
				state.unconfirmedApplications.push(application);
			}

			localStorage.setItem(
				"unconfirmedApplications",
				JSON.stringify(state.unconfirmedApplications)
			);
		},
		removeUnconfirmedApplication(state, email) {
			state.unconfirmedApplications =
				state.unconfirmedApplications.filter(
					(app) => app.email !== email
				);
			localStorage.setItem(
				"unconfirmedApplications",
				JSON.stringify(state.unconfirmedApplications)
			);
		},
		setUnconfirmedApplicationsFromLocalStorage(state, applications) {
			state.unconfirmedApplications = applications;
		},

		// Mutations for project applications
		addUnconfirmedProjectApplication(state, application) {
			const existingIndex =
				state.unconfirmedProjectApplications.findIndex(
					(app) =>
						app.email === application.email &&
						app.volunteeringId === application.volunteeringId
				);
			if (existingIndex !== -1) {
				// If an application with the same email and volunteeringId exists, update its data
				state.unconfirmedProjectApplications[existingIndex] =
					application;
			} else {
				// Otherwise, add the new application
				state.unconfirmedProjectApplications.push(application);
			}

			localStorage.setItem(
				"unconfirmedProjectApplications",
				JSON.stringify(state.unconfirmedProjectApplications)
			);
		},
		removeUnconfirmedProjectApplication(state, { email, volunteeringId }) {
			state.unconfirmedProjectApplications =
				state.unconfirmedProjectApplications.filter(
					(app) =>
						app.email !== email ||
						app.volunteeringId !== volunteeringId
				);
			localStorage.setItem(
				"unconfirmedProjectApplications",
				JSON.stringify(state.unconfirmedProjectApplications)
			);
		},
		setUnconfirmedProjectApplicationsFromLocalStorage(state, applications) {
			state.unconfirmedProjectApplications = applications;
		},
	},
	actions: {
		retrieveLanguageType({ state }) {
			native_capacitor
				.getItem("language")
				.then((result) => {
					if (result.value && !isNaN(result.value)) {
						state.type_language = result.value;
					} else {
						state.type_language = 1;
					}
				})
				.catch((err) => {
					state.type_language = 1;
				});
		},
		addUnconfirmedApplication({ commit }, application) {
			commit("addUnconfirmedApplication", application);
		},
		removeUnconfirmedApplication({ commit }, email) {
			commit("removeUnconfirmedApplication", email);
		},
		initializeUnconfirmedApplications({ commit }) {
			const applications =
				JSON.parse(localStorage.getItem("unconfirmedApplications")) ||
				[];
			commit("setUnconfirmedApplicationsFromLocalStorage", applications);
		},

		// Actions for managing project applications
		addUnconfirmedProjectApplication({ commit }, application) {
			commit("addUnconfirmedProjectApplication", application);
		},
		removeUnconfirmedProjectApplication(
			{ commit },
			{ email, volunteeringId }
		) {
			commit("removeUnconfirmedProjectApplication", {
				email,
				volunteeringId,
			});
		},
		initializeUnconfirmedProjectApplications({ commit }) {
			const applications =
				JSON.parse(
					localStorage.getItem("unconfirmedProjectApplications")
				) || [];
			commit(
				"setUnconfirmedProjectApplicationsFromLocalStorage",
				applications
			);
		},
	},
};

export default new Vuex.Store(store);
